import type { ReactNode } from 'react';
import { AdHexMark } from './AdHexMark';
import './match-intro.css';

type Props = {
  children?: ReactNode;
  /** 0–1 while loading */
  progress?: number;
  showLoadBar?: boolean;
};

function AdMark({ className }: { className?: string }) {
  return (
    <div className={`match-intro__mark ${className ?? ''}`} aria-hidden>
      <AdHexMark size={52} />
    </div>
  );
}

/** Cinematic match-night intro — gold / black / white only. */
export function MatchIntroShell({
  children,
  progress = 1,
  showLoadBar = true,
}: Props) {
  const pct = Math.round(Math.min(1, Math.max(0, progress)) * 100);

  return (
    <div className="match-intro">
      <div className="match-intro__cam" aria-hidden>
        <div className="match-intro__bg" />
        <div className="match-intro__spot" />
        <div className="match-intro__fog match-intro__fog--a" />
        <div className="match-intro__fog match-intro__fog--b" />
        <div className="match-intro__rays" />
        <div className="match-intro__dust" />
        <div className="match-intro__crowd" />
      </div>

      <div className="match-intro__grade" aria-hidden />
      <div className="match-intro__vignette" aria-hidden />
      <div className="match-intro__scan" aria-hidden />

      <AdMark className="match-intro__mark--tl" />

      <div className="match-intro__side match-intro__side--l" aria-hidden>
        <span>Projects</span>
        <span>Experience</span>
        <span>Skills</span>
        <span>Contact</span>
      </div>
      <div className="match-intro__side match-intro__side--r" aria-hidden>
        <span>AI</span>
        <span>Full Stack</span>
        <span>Automation</span>
        <span>Cloud</span>
      </div>

      <div className="match-intro__stage">
        <div className="match-intro__hud" aria-hidden>
          <span className="match-intro__ring" />
          <span className="match-intro__ring match-intro__ring--soft" />
          <span className="match-intro__cross match-intro__cross--h" />
          <span className="match-intro__cross match-intro__cross--v" />
          <span className="match-intro__corner match-intro__corner--tl" />
          <span className="match-intro__corner match-intro__corner--tr" />
          <span className="match-intro__corner match-intro__corner--bl" />
          <span className="match-intro__corner match-intro__corner--br" />
          <span className="match-intro__plus match-intro__plus--a" />
          <span className="match-intro__plus match-intro__plus--b" />
        </div>

        <h1 className="match-intro__title">
          <span className="match-intro__title-chrome">The Final</span>
        </h1>
        <p className="match-intro__sub">Engineering Portfolio</p>

        {children}
      </div>

      {showLoadBar && (
        <div className="match-intro__load" aria-live="polite">
          <span className="match-intro__load-label">Initializing Experience</span>
          <div className="match-intro__load-track">
            <i style={{ width: `${pct}%` }} />
          </div>
          <span className="match-intro__load-pct">{pct}%</span>
        </div>
      )}

      <div className="match-intro__flash" aria-hidden />
    </div>
  );
}
